//
const titleGuardianServiceButton = document.querySelector('.service-button[data-service="title-guardian"]')

//
if (titleGuardianServiceButton !== null) {

    //
    const getResponse = require('../utils/getResponse.js');
    const createElement = require('../utils/createElement.js');

    //toggle the information panel as needed
    titleGuardianServiceButton.addEventListener('click', function (event) {
        if (event.target.matches('[data-action="toggle-service-information"]') == true) {
            event.target.closest('.service-button').setAttribute('data-show-service-information', ((titleGuardianServiceButton.dataset.showServiceInformation == 'no') ? 'yes' : 'no'));
        }
    });

    //
    titleGuardianServiceButton.querySelector('button[data-action="get-title-guardian-token"]').addEventListener('click', function (event) {

        //
        if (event.target.disabled == true) {
            return false;
        }

        //
        event.preventDefault(); event.stopPropagation();

        //
        event.target.disabled = true;

        //
        getResponse('/api/get-title-guardian-service-token').then((response) => {

            //
            titleGuardianServiceButton.querySelector('.service-button-button').classList.add('hidden');

            //
            if (response.details.responseStatus === 200) {

                //mobile view
                mobileView = createElement('div', { 'class': 'title-guardian-mobile-sign-up' });

                //
                mobileView.append(createElement('a', { 'class': 'btn btn-primary mobile-sign-up-url', 'href': response.details.mobileSignUpUrl }, 'Download the app to sign up'));
                link = createElement('p');
                link.append(createElement('a', { 'class': 'sign-up-url', 'href': response.details.signUpUrl }, 'Not on a mobile device?'));
                mobileView.append(link)

                //desktop view
                desktopView = createElement('div', { 'class': 'title-guardian-desktop-sign-up' });

                //
                desktopView.append(createElement('img', { 'class': 'sign-up-qr', 'src': response.details.QRCode }));
                desktopView.append(createElement('p'))
                desktopView.querySelector('p').append(createElement('a', { 'class': 'mobile-sign-up-url', 'href': response.details.mobileSignUpUrl }, 'On a mobile device?'));
                desktopView.append(createElement('a', { 'class': 'btn btn-primary btn-large sign-up-url', 'href': response.details.signUpUrl }, 'Sign up on desktop'));

                //
                titleGuardianServiceButton.append(mobileView);
                titleGuardianServiceButton.append(desktopView);

                //
                return;
            }

            //
            if (response.details.responseStatus === 409) {

                //
                alreadyRegisteredView = createElement('div', { 'class': 'title-guardian-already-registered', 'data-signUpUrl': response.details.signInUrl, 'data-mobileSignUpUrl': response.details.mobileSignInUrl });

                //
                alreadyRegisteredView.append(createElement('p', {}, 'Looks like you already have an account with Title Guardian, '));
                alreadyRegisteredView.querySelector('p').append(createElement('a', { 'class': 'mobile-sign-up-url', href: response.details.mobileSignInUrl }, 'click here to log in.'));
                alreadyRegisteredView.querySelector('p').append(createElement('a', { 'class': 'sign-up-url', href: response.details.signInUrl }, 'click here to log in.'));

                //
                titleGuardianServiceButton.append(alreadyRegisteredView);

                //
                return;

            }

            //
            errorResponse = createElement('div', { 'class': 'title-guardian-error-response' });

            //
            errorResponse.append(createElement('p', {}, response.message));

            //
            titleGuardianServiceButton.append(errorResponse);

            return;

        });

    });

}